import React, { useMemo } from 'react'
import { maskNumbers, unmaskNumbers } from '../../../../utils/types/mask'
import { FieldProps } from '../../../hooks/form'
import { Input, MaskedInput, TextArea } from '../../input'
import Wrapper from './wrapper'

export default function StringField({
  id,
  fieldSchema: {
    currentMeta: {
      label,
      maxLength = undefined,
      mask = undefined,
      inputType = 'text',
      isDisabled = false,
      lines = 1,
    },
    currentRules: { isRequired },
  },
  value,
  onDirectChange,
  onBlur,
  onKeyDown,
  children,
}: FieldProps<any> & { children?: React.ReactNode }) {
  const valueWithMask = useMemo<null | string>(
    () => (value && mask ? maskNumbers(String(value), mask) : null),
    [mask, value],
  )

  if (mask) {
    return (
      <Wrapper isRequired={isRequired} label={label} id={id}>
        <MaskedInput
          mask={mask}
          type='text'
          id={id as string}
          value={valueWithMask ? String(valueWithMask) : ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            if (!onDirectChange) {
              return
            }
            onDirectChange(event.target.value ? unmaskNumbers(event.target.value) : null)
          }}
          onBlur={onBlur}
          autoComplete='off'
          className='input'
          maxLength={maxLength}
        />
        {children}
      </Wrapper>
    )
  }

  return (
    <Wrapper isRequired={isRequired} label={label} id={id}>
      {lines === 1 ? (
        <Input
          type={inputType}
          id={id as string}
          value={value ? String(value) : ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            if (!onDirectChange) {
              return
            }
            onDirectChange(event.target.value || null)
          }}
          onKeyDown={onKeyDown}
          onBlur={onBlur}
          autoComplete='off'
          className='input'
          maxLength={maxLength}
          disabled={isDisabled}
        />
      ) : (
        <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
          <div style={{ display: 'flex', flex: 1, flexDirection: 'row' }}>
            <TextArea
              id={id as string}
              value={value ? String(value) : ''}
              onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
                if (!onDirectChange) {
                  return
                }
                onDirectChange(event.target.value || null)
              }}
              onBlur={onBlur}
              autoComplete='off'
              className='textarea'
              maxLength={500}
              disabled={isDisabled}
              rows={Number(lines)}
            />
          </div>
          <div
            style={{
              display: 'flex',
              marginTop: '3px',
              flexDirection: 'row',
              justifyContent: 'flex-end',
            }}
          >
            <span>500</span>
          </div>
        </div>
      )}
      {children}
    </Wrapper>
  )
}
